import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { setPosition } from './actions'

function mapStateToProps(state, hocProps) {
    return {
        position: state.getIn(['ui', 'modules', hocProps.moduleName, 'ribbon', hocProps.name, 'position'], 0),
        maxPosition: state.getIn(['ui', 'modules', hocProps.moduleName, 'ribbon', hocProps.name, 'maxPosition'], 0),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ setPosition }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        static propTypes = {
            configuration: IPropTypes.list.isRequired,
            maxPosition: PropTypes.number.isRequired,
            position: PropTypes.number.isRequired,
        }

        shouldComponentUpdate(nextProps) {
            if (this.props.position !== nextProps.position) return true
            if (this.props.maxPosition !== nextProps.maxPosition) return true
            if (!this.props.configuration.equals(nextProps.configuration)) return true

            return false
        }

        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
